<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0em;">Neil Webster – Copy, advice, friendship and a good listener when I needed one.</p><br/>
<p style="text-indent:0em;">Anyone that made life a challenge – you truly gave me the gift of the contents of this book, and I wish you all happiness.</p>
<p style="text-indent:0em;">Messrs Steve Vai and Joe Satriani for the music these experiences were always played out to either in my head or on my Walkman.</p><br/>
<p style="text-indent:0em;">Illy for the endless espresso – the lifeblood of my creativity.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?5b056423